import { MasterServer, MasterServerConfig } from "../Master.js";

const ERROR_MESSAGE = "Method not implemented. Create your own master server class by extending from gotti/MasterServer.ts if you want to use this method";

export class DefaultMasterServer extends MasterServer {
  onAuthenticateAdmin(payload: any): Promise<boolean> {
    throw new Error(ERROR_MESSAGE);
  }
  onAdminPost(endpoint: string, payload: any): Promise<any> {
    throw new Error(ERROR_MESSAGE);
  }
  onAdminGet(endpoint: string, payload: any): Promise<any> {
    throw new Error(ERROR_MESSAGE);
  }
  onAreaMessage(areaId: string, message: { type: string | number; data: any; }): void {
    throw new Error(ERROR_MESSAGE);
  }
  onAreaRequest(areaId: string, request: { type: string | number; data: any; }): Promise<any> {
    throw new Error(ERROR_MESSAGE);
  }
  constructor(config: MasterServerConfig) {
    super(config);
  }
}